import config from '../../config';

import { FC, memo, SyntheticEvent } from 'react';
import { useParams } from 'react-router-dom';
// Models
import { RootState } from 'app/store';
import IAnnotation from 'app/models/Annotation';
import IPage, { IPresenterPage } from 'app/models/Page';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectPageEntity } from 'app/store/DMSDocumentPages/DMSDocumentPages.selectors';

type Props = {
  documentId: number;
  pageNum: number;
  onImageLoaded: (e:SyntheticEvent<HTMLImageElement>) => void;
}

const InjestedPageImage:FC<Props> = ({
  // Props
  documentId, pageNum, onImageLoaded
}) => {
  const { insuranceCaseId, caseId } = useParams<{ insuranceCaseId:string, caseId:string }>();
  // State
  const page:IPage | IPresenterPage | undefined = useAppSelector((state:RootState) => selectPageEntity(state, { documentId, pageNum }))

  const alt = `${insuranceCaseId || caseId}_${documentId}_${pageNum}.png`;
  let src = `${config.cdnUrl}/pages/${alt}`;

  if ( !page ) return null;

  // Get rotations
  if ( page.annotations && page.annotations.length ){
    const manualRotation = page.annotations.find((annotation:IAnnotation) => annotation.name === 'manualRotation');
    if ( manualRotation && manualRotation.value ) src += `?rotation=${manualRotation.value}`;
  }
  return (
    <img src={src} alt={alt} loading="lazy" onLoad={onImageLoaded} />
  )
}

export default memo(InjestedPageImage);